<div class="container-login">
  <div class="content-login">
    <div class="logo-login" title="NTT Data, Inc."></div>

    <hr class="divisor-login" />

    <div class="info-login">
      <strong>Pick an account</strong>
      <p>select your account for access</p>
    </div>

    <div class="avatar-login">
      <span class="avatar-img" [title]="content?.username"></span>

      <span class="avatar-info">
        <strong>{{ username ? username : 'Sign in' }}</strong>
        <small>{{ soCapture ? soCapture[0] : 'Sign in to proceed.' }}</small>
      </span>
    </div>

    <button class="btn btn-login" [ngClass]="{ disabled: disableBtn }" (click)="login()">Login</button>

    <hr class="divisor-login" />

    <span class="support-login">
      <i class="support-img"></i> Can't access?
      <a
        href="mailto:AM.US.OM.BusinessSolutions@global.ntt?Subject=Help!&Body=I can't log in to the platform. %0D%0AWould you help me?"
        title="Click to send mail"
        (click)="disableBtnTime()"
        >Click here</a
      >
      to contact the support
    </span>
  </div>
</div>
